module.exports = __webpack_public_path__ + "img/globe.c669d0d7.svg";